export default __webpack_public_path__ + "assets/models/bce27fd6534d32f8922b1e43bd1cf12b.glb";